module.exports = __webpack_public_path__ + "img/path-1.af8d2dfd.svg";